import { UserMenu } from "./UserMenu";

export const LegalLinks = () => {
  return (
    <nav
      id={"legallinks"}
      aria-label={I18N("aria::Rechtliche Links")}
      data-group-key="Rechtliche-Links"
    >
      <ul>
        <li>
          <a
            href={I18N("Barrierefreiheit_url")}
            target={"_blank"}
            aria-label={I18N("aria::Barrierefreiheitserklärung öffnen")}
            data-button-key="Barrierefreiheit"
          >
            {I18N("Barrierefreiheit")}
          </a>
        </li>
        <li>
          <a
            href={I18N("Datenschutz_url")}
            target={"_blank"}
            aria-label={I18N("aria::Datenschutz öffnen")}
            data-button-key="Datenschutz"
          >
            {I18N("Datenschutz")}
          </a>
        </li>
        <li>
          <a
            href={I18N("Impressum_url")}
            target={"_blank"}
            aria-label={I18N("aria::Impressum öffnen")}
            data-button-key="Impressum"
          >
            {I18N("Impressum")}
          </a>
        </li>
      </ul>
      {APP.settings.ZeigeUserMenu && (
        <UserMenu additionalClasses="mobileOnly" align="right" />
      )}
    </nav>
  );
};
